import { inject, singleton } from "@launchtray/tsyringe-async";
import { IPreloaderModel } from "./IPreloaderModel";
import { Bindable } from "bindable-data";
import { NotifyProperty } from "bindable-data";
import { ResourcesInitializer } from "../initializers/ResourcesInitializer";
import { IContextResolver } from "../../../composition/IContextResolver";

@singleton()
export class PreloaderModel extends Bindable implements IPreloaderModel {
    private initializationStarted: boolean;
    private readonly contextResolver: IContextResolver;
    public readonly progress: NotifyProperty<number>;

    public constructor(@inject("IContextResolver") contextResolver: IContextResolver) {
        super();
        this.contextResolver = contextResolver;
        this.initializationStarted = false;
        this.progress = new NotifyProperty<number>(this, "progress", 0);
    }

    public async runInitializers(): Promise<void> {
        if (this.initializationStarted) {
            throw new Error("Initialization has already been started.");
        }
        this.initializationStarted = true;
        const resourcesInitializer = await this.contextResolver.resolve(ResourcesInitializer);
        resourcesInitializer.onInitializationProgress.add(this.handleResourcesLoadingProgress, this);
        await resourcesInitializer.start();
    }

    private handleResourcesLoadingProgress(progress: number): void {
        this.progress.setValue(progress);
    }
}
